import { combineReducers } from "redux";

import { currenyDetails } from "./reducer.currency"
const currencyReducers = combineReducers({

  currenyDetails

})
export default currencyReducers;
